import LoyaltyClubForm from './loyalty-club-form';

export default LoyaltyClubForm;
